import React, { useState } from "react";
import { Tabs, Tab, Box, Typography } from "@material-ui/core";
import { withStyles, makeStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import YourAccounts from "./_your_accounts";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  tab: {
    "& .MuiBox-root": {
      padding: "6px",
      paddingTop: "10px",
    },
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const AntTabs = withStyles((theme) => ({
  root: {
    borderBottom: "1px solid " + theme.palette.eSecondary?.base,
    minHeight: "0px",
    "& button": {
      minHeight: "35px",
    },
  },
  indicator: {
    backgroundColor: theme.palette.eSecondary?.base,
  },
}))(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    textTransform:"capitalize"
  },
  selected: {
    background: theme.palette.eSecondary?.selected + " !important",
    color: theme.palette.eWhite?.base + " !important",
    borderRadius: "10px 10px 0px 0px",
    cursor: "default !important"
  },
}))(Tab);

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function AccountInfo() {
  const [value, setValue] = useState(0);
  let classes = useStyles();
  const handleChange = (e, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <TabPanel value={value} index={0} className={classes.tab}>
        <YourAccounts />
      </TabPanel>
    </>
  );
}
